// import React, { useState } from "react";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
// import GMP from "../assets/img/certificates/GMP.jpg";
// import IEC from "../assets/img/certificates/IEC.jpg";
// import Certificate from "../assets/img/certificates/Certificate.jpg";
// import MSME from "../assets/img/certificates/MSME.jpg";

// const certificates = [
//   {
//     id: 1,
//     title: "IEC Certified",
//     img: IEC,
//   },
//   {
//     id: 2,
//     title: "GMP Certified",
//     img: GMP,
//   },
//   {
//     id: 3,
//     title: "Certification",
//     img: Certificate,
//   },
//   {
//     id: 4,
//     title: "MSME Certified",
//     img: MSME,
//   },
  
//   // Add more if needed
// ];

// const responsive = {
//   desktop: {
//     breakpoint: { max: 3000, min: 1024 },
//     items: 4,
//     slidesToSlide: 1, // slide one by one
//   },
//   tablet: {
//     breakpoint: { max: 1024, min: 464 },
//     items: 2,
//     slidesToSlide: 1,
//   },
//   mobile: {
//     breakpoint: { max: 464, min: 0 },
//     items: 1,
//     slidesToSlide: 1,
//   },
// };

// export default function Certifications() {
//   const [currentSlide, setCurrentSlide] = useState(0);

//   return (
//     <div className="container mx-auto px-6 py-20">
//       <h2 className="text-3xl font-bold text-center mb-10">
//         Our <span className="text-[#f98715]">Certifications</span>
//       </h2>

//       <Carousel
//         responsive={responsive}
//         ssr={true} // Server side rendering
//         infinite={true}
//         autoPlay={true}
//         autoPlaySpeed={2500}
//         keyBoardControl={true}
//         showDots={false}
//         arrows={false}
//         slidesToSlide={1}
//         beforeChange={(next) => setCurrentSlide(next)}
//         containerClass="carousel-container"
//         itemClass="carousel-item-padding-10-px"
//         customTransition="transform 0.5s ease-in-out"
//       >
//         {certificates.map((cert, index) => {
//           // Calculate zoom scale: 1.1 for the current slide, 1 for others
//           // Since it's a multi-carousel showing 4, find active visible slides range
//           // currentSlide is the index of the leftmost visible slide
//           // Zoom the visible items by their position relative to currentSlide
//           let scale = 1;
//           if (index >= currentSlide && index < currentSlide + 4) {
//             // Zoom in the middle item of visible 4? Let's zoom the second item (index currentSlide +1)
//             // or we can zoom each item as it becomes the leftmost
//             // To zoom one by one, zoom the item at currentSlide + 1 (second item)
//             if (index === currentSlide + 1) {
//               scale = 1.1;
//             }
//           }

//           // Adjust for infinite loop index overflow
//           // Because of infinite loop, index can be out of range, but react-multi-carousel handles internally.
//           // This approximation should work for demonstration.

//           return (
//             <div
//               key={cert.id}
//               className="p-4 transition-transform duration-500 ease-in-out"
//               style={{ transform: `scale(${scale})` }}
//             >
//               <div className="bg-white rounded-xl shadow-lg p-4 flex flex-col items-center">
//                 <img
//                   src={cert.img}
//                   alt={cert.title}
//                   className="w-full h-96 object-contain mb-1"
//                 />
//                 <h3 className="text-lg font-semibold text-center">
//                   {cert.title}
//                 </h3>
//               </div>
//             </div>
//           );
//         })}
//       </Carousel>
//     </div>
//   );
// }


import React, { useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { motion, AnimatePresence } from "framer-motion";

import GMP from "../assets/img/certificates/GMP.jpg";
import IEC from "../assets/img/certificates/IEC.jpg";
import Certificate from "../assets/img/certificates/Certificate.jpg";
import MSME from "../assets/img/certificates/MSME.jpg";

const certificates = [
  { id: 1, title: "IEC Certified", img: IEC },
  { id: 2, title: "GMP Certified", img: GMP },
  { id: 3, title: "Certified Company", img: Certificate },
  { id: 4, title: "MSME Certified", img: MSME },
];

const responsive = {
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4, slidesToSlide: 1 },
  tablet:  { breakpoint: { max: 1024, min: 464 }, items: 2, slidesToSlide: 1 },
  mobile:  { breakpoint: { max: 464,  min: 0 },   items: 1, slidesToSlide: 1 },
};

export default function Certifications() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selected, setSelected] = useState<null | typeof certificates[0]>(null);

  return (
    <div className="container mx-auto px-6 py-20">
      <h2 className="text-5xl font-bold text-center mb-10">
        Our <span className="text-[#f98715]">Certifications</span>
      </h2>

      {/* ── CAROUSEL ────────────────────────────────────────── */}
      <Carousel
        responsive={responsive}
        ssr
        infinite
        autoPlay
        autoPlaySpeed={2500}
        keyBoardControl
        arrows={false}
        showDots={false}
        slidesToSlide={1}
        beforeChange={(next) => setCurrentSlide(next)}
        containerClass="carousel-container"
        itemClass="carousel-item-padding-10-px"
        customTransition="transform 0.5s ease-in-out"
      >
        {certificates.map((cert, index) => {
          // Simple zoom logic: second visible item gets a slight scale‑up
          let scale = 1;
          if (index >= currentSlide && index < currentSlide + 4 && index === currentSlide + 1) {
            scale = 1.1;
          }

          return (
            <div
              key={cert.id}
              className="p-4 cursor-pointer transition-transform duration-500 ease-in-out"
              style={{ transform: `scale(${scale})` }}
              onClick={() => setSelected(cert)}
            >
              <div className="bg-white rounded-xl shadow-lg p-4 flex flex-col items-center">
                <img
                  src={cert.img}
                  alt={cert.title}
                  className="w-full h-96 object-contain mb-2"
                />
                <h3 className="text-lg font-semibold text-center">{cert.title}</h3>
              </div>
            </div>
          );
        })}
      </Carousel>

      {/* ── POPOVER ─────────────────────────────────────────── */}
      <AnimatePresence>
        {selected && (
          <motion.div
            key="overlay"
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 py-10 lg:px-10 px-4 "
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelected(null)}
          >
            <motion.div
              key="modal"
              className="bg-white rounded-2xl shadow-2xl p-8 max-w-lg w-full"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1,   opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", stiffness: 260, damping: 20 }}
              onClick={(e) => e.stopPropagation()}   // Prevent backdrop click
            >
              <button
                className="ml-auto mb-2 text-gray-500 hover:text-gray-700 text-xl"
                onClick={() => setSelected(null)}
              >
                &times;
              </button>
              <img
                src={selected.img}
                alt={selected.title}
                className="w-full h-auto object-contain mb-0"
              />
              {/* <h3 className="text-2xl font-semibold text-center">{selected.title}</h3> */}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

